import { connect } from 'react-redux';

import WaterTracking from '~/Components/Global/Water/WaterTracking';

import { updateWater } from '~/Redux/Modules/Water';
import { setTracker } from '~/Redux/Modules/DayTrackers';

const mapStateToProps = ({ Water, DateRange }) => {
  return {
    water: Water.data,
    isFetching: Water.isFetching,
    day: DateRange.start.toString(),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateWater: (drink, date, id) => dispatch(updateWater(drink, date, id)),
    setTracker: opt => dispatch(setTracker(opt)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WaterTracking);
